export enum TipoConfiguracionEtiquetaEnum { ITEM, REGION, CIUDAD, PERFIL }

const nombresTipoConfiguracionEtiqueta = new Map<TipoConfiguracionEtiquetaEnum, string>();
nombresTipoConfiguracionEtiqueta.set(TipoConfiguracionEtiquetaEnum.ITEM, "Item");
nombresTipoConfiguracionEtiqueta.set(TipoConfiguracionEtiquetaEnum.REGION, "Region");
nombresTipoConfiguracionEtiqueta.set(TipoConfiguracionEtiquetaEnum.CIUDAD, "Ciudad");
nombresTipoConfiguracionEtiqueta.set(TipoConfiguracionEtiquetaEnum.PERFIL, "Perfil");

export const obtenerNombresTipoConfiguracionEtiqueta: () => Array<[TipoConfiguracionEtiquetaEnum, string]> =
    () => Array.from(nombresTipoConfiguracionEtiqueta.entries());
